/* eslint-disable import/prefer-default-export */
import { API_URL } from '../../../../utils/config';

export const HOTSPOT_SERVER_URL = `${API_URL}/hotspotServer`;
